import React from "react";
import {
  settingsPageLoad,
  settingsUpdateRequest,
  settingsEmailAddRequest,
  settingsEmailDeleteRequest,
} from "../../actions/global-settings";
import {
  settings,
  settingsLoadInProgress,
} from "../../selectors/global-settings";
import { connect } from "react-redux";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import GlobalSettingsForm from "../../components/forms/GlobalSettings";
import TableWithAddForm from "../../../../components/TableWithAddForm";
import { Row, Col, Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default props => <EditGeneralSettings />;

const EditGeneralSettings = connect(
  (state, ownProps) => ({
    globalSettings: settings(state),
    loading: settingsLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(settingsPageLoad()),
    onSave: formData => dispatch(settingsUpdateRequest(formData)),
    onAddEmail: email => dispatch(settingsEmailAddRequest(email)),
    onDeleteEmail: email => dispatch(settingsEmailDeleteRequest(email)),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading) {
      return <PageTitle title="Loading..." />;
    }
    return (
      <div id="global-settings-page">
        <PageTitle title="Global settings" />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Global data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <GlobalSettingsForm
                  globalSettings={props.globalSettings}
                  onSave={props.onSave}
                  disabled={props.globalSettings.generalDataSaveInProgress}
                  backendError={props.globalSettings.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              Global email address contacts
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <TableWithAddForm
                  title="Email"
                  email
                  helpText="Enter any email addresses that should ALWAYS be contacted, regardless of Region or Engineer. These will be displayed in the on-call Engineer search results."
                  disabled={props.globalSettings.emailAddInProgress}
                  backendError={props.globalSettings.emailAddError}
                  data={props.globalSettings.emails}
                  onAdd={props.onAddEmail}
                  onDelete={props.onDeleteEmail}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/GlobalSettingsPage.js